import { css, html, LitElement } from "lit";

import { fetchUserById } from "../common/api";
import { getPlayerNameColor } from "../common/utils";
import { websiteStyles } from "../styles/website";

export class DiscordUserComponent extends LitElement {
  constructor() {
    super();
    this.userID = "";
    /** @type {DiscordUserData} */
    this.userData = null;
  }

  static styles = [
    websiteStyles,
    css`
    .username {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
    `,
  ];

  async loadData() {
    this.userData = await fetchUserById(this.userID, true);
    this.requestUpdate();
  }

  firstUpdated() {
    this.loadData();
  }

  render() {
    if (!this.userData) {
      return null;
    }
    return html`
            <div class="discord-user">
                <img src="${
                  this.userData.avatar
                    ? this.userData.avatar
                    : "./images/logo.jpeg"
                }" alt="${this.userData.username}" class="player-icon" /> <a href="/user/${this.userID}" class="username" style="color: ${getPlayerNameColor(this.userData.xp)}">${this.userData.username}</a>
            </div>
        `;
  }
}

window.customElements.define("discord-user-component", DiscordUserComponent);
